module.exports = __webpack_public_path__ + "img/refresh-icon-alt.df8ff848.svg";